import * as i0 from "@angular/core";
var DateService = /** @class */ (function () {
    function DateService() {
        this.days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
    }
    DateService.prototype.getWeekDayName = function (date) {
        var d;
        if (date) {
            d = new Date(date);
        }
        else {
            d = new Date();
        }
        return this.days[d.getDay()];
    };
    DateService.prototype.getDateSafariSupport = function (date) {
        if (date) {
            return date.replace(/\s/g, 'T');
        }
        else {
            return '';
        }
    };
    DateService.prototype.msToTime = function (duration) {
        var seconds = parseInt(String((duration / 1000) % 60));
        var minutes = parseInt(String((duration / (1000 * 60)) % 60));
        var hours = parseInt(String((duration / (1000 * 60 * 60)) % 24));
        var days = parseInt(String(duration / (1000 * 60 * 60 * 24)));
        var daysTitle = days === 1 ? 'day' : "days";
        hours = (hours < 10) ? "0" + String(hours) : hours;
        minutes = (minutes < 10) ? "0" + String(minutes) : minutes;
        seconds = (seconds < 10) ? "0" + String(seconds) : seconds;
        return days ? (days + " " + daysTitle + " " + hours + ":" + minutes + ":" + seconds) : (hours + ":" + minutes + ":" + seconds);
    };
    DateService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function DateService_Factory() { return new DateService(); }, token: DateService, providedIn: "root" });
    return DateService;
}());
export { DateService };
